// Single source of truth for standalone, pre-login (no-auth) routes.
//
// These routes render outside the authenticated <Main> shell and are meant to
// be usable while logged out (public credential verify, Voila board, Atlas,
// Kiosk, the product marketplace/catalog, and the registration flows). Two
// things must treat them specially:
//   1. myAxios must NOT surface the "Session Expired" modal for stray 401s that
//      happen on these pages — there is no session to expire.
//   2. App.checkValidUser() must NOT run the verify-or-logout redirect on them.
//
// Match is case-insensitive and boundary-safe: a path matches when it equals a
// prefix exactly or continues with "/" (so "/register" doesn't swallow
// "/registercentre").
export const PUBLIC_PREFIXES = [
  "/verify",
  "/voila",
  "/atlas",
  "/saarthi",
  "/kiosk",
  "/quote-builder",
  "/products",
  "/productdetails",
  "/register",
  "/parent-register",
  "/alumni-register",
];

export function isPublicPreloginPath(pathname) {
  if (!pathname) return false;
  const p = String(pathname).toLowerCase();
  return PUBLIC_PREFIXES.some(
    (prefix) => p === prefix || p.startsWith(prefix + "/")
  );
}
